var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle, _circle2, _circle3, _circle4, _rect, _circle5, _circle6, _rect2, _circle7, _circle8, _rect3, _ellipse, _path10, _path11, _circle9, _circle10, _circle11, _circle12, _rect4, _ellipse2, _path12, _path13, _path14, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPut1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 140,
    viewBox: "0 0 194 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.231445 119.686H192.123",
    stroke: "#31B047",
    strokeWidth: 0.902326
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M120.284 0L120.284 139.008",
    stroke: "#31B047",
    strokeWidth: 0.902326
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M135.027 69.5039L0.000313837 69.5039",
    stroke: "black",
    strokeWidth: 0.902326,
    strokeDasharray: "3.61 3.61"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1064 56.7055L19.0922 56.2546L19.0242 56.2568L18.9599 56.2788L19.1064 56.7055ZM35.5373 56.1859L35.5516 56.6368L35.639 56.6341L35.719 56.5989L35.5373 56.1859ZM51.9682 48.9593L51.8093 48.5371L51.7978 48.5414L51.7866 48.5463L51.9682 48.9593ZM66.1585 43.6165L66.1949 43.1668L66.0942 43.1586L65.9996 43.1943L66.1585 43.6165ZM84.83 45.1268L84.7937 45.5765L84.9041 45.5854L85.0061 45.5421L84.83 45.1268ZM101.261 38.16L101.225 37.7103L101.152 37.7161L101.085 37.7446L101.261 38.16ZM117.692 36.8365L117.728 37.2862L117.832 37.2778L117.922 37.2242L117.692 36.8365ZM137.133 25.2739L131.924 25.3414L134.587 29.8189L137.133 25.2739ZM0.377933 63.6118L19.2529 57.1323L18.9599 56.2788L0.0849574 62.7584L0.377933 63.6118ZM19.1207 57.1565L35.5516 56.6368L35.5231 55.7349L19.0922 56.2546L19.1207 57.1565ZM35.719 56.5989L52.1499 49.3723L51.7866 48.5463L35.3557 55.7729L35.719 56.5989ZM52.1272 49.3815L66.3175 44.0387L65.9996 43.1943L51.8093 48.5371L52.1272 49.3815ZM66.1222 44.0662L84.7937 45.5765L84.8664 44.6771L66.1949 43.1668L66.1222 44.0662ZM85.0061 45.5421L101.437 38.5754L101.085 37.7446L84.6539 44.7114L85.0061 45.5421ZM101.297 38.6097L117.728 37.2862L117.656 36.3868L101.225 37.7103L101.297 38.6097ZM117.922 37.2242L133.874 27.7373L133.412 26.9618L117.461 36.4487L117.922 37.2242Z",
    fill: "#31B047"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.231445 73.7162L19.1064 80.1958L35.5373 80.7155L51.9682 87.9421L66.1585 93.2849L84.83 91.7746L101.261 98.7414L117.692 100.065L137.133 111.627",
    stroke: "#FFD44B",
    strokeWidth: 0.902326,
    strokeDasharray: "3.61 3.61"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M147.479 72.3264C148.72 72.3264 149.467 71.7237 149.467 70.7755V70.772C149.467 69.9789 149.005 69.5489 147.948 69.3304L147.398 69.2176C146.785 69.0907 146.506 68.8792 146.506 68.5197V68.5162C146.506 68.1108 146.876 67.8324 147.472 67.8289C148.043 67.8289 148.434 68.0932 148.494 68.5373L148.501 68.5796H149.372L149.368 68.5197C149.315 67.6491 148.589 67.064 147.479 67.064C146.383 67.064 145.597 67.6703 145.593 68.5655V68.5691C145.593 69.3269 146.087 69.7921 147.088 70.0001L147.634 70.1129C148.29 70.2503 148.554 70.4548 148.554 70.8354V70.839C148.554 71.276 148.152 71.5615 147.511 71.5615C146.873 71.5615 146.425 71.2901 146.358 70.8531L146.351 70.8108H145.48L145.484 70.8636C145.544 71.7765 146.312 72.3264 147.479 72.3264ZM151.25 72.2383H152.156V67.917H153.675V67.1521H149.728V67.917H151.25V72.2383ZM154.299 72.2383H155.209V70.3349H156.192L157.193 72.2383H158.229L157.119 70.1975C157.711 69.9825 158.078 69.4291 158.078 68.7453V68.7382C158.078 67.7549 157.415 67.1521 156.329 67.1521H154.299V72.2383ZM155.209 69.6159V67.8888H156.217C156.788 67.8888 157.147 68.2131 157.147 68.7453V68.7523C157.147 69.2987 156.809 69.6159 156.234 69.6159H155.209ZM158.811 72.2383H159.72V67.1521H158.811V72.2383ZM160.615 72.2383H161.525V70.5993L162.025 70.0036L163.608 72.2383H164.715L162.681 69.3974L164.56 67.1521H163.52L161.55 69.5384H161.525V67.1521H160.615V72.2383ZM165.191 72.2383H168.483V71.4734H166.1V70.0248H168.352V69.2881H166.1V67.917H168.483V67.1521H165.191V72.2383ZM170.717 72.2383H171.627V70.557H172.677C173.706 70.557 174.408 69.8732 174.408 68.8581V68.851C174.408 67.8324 173.706 67.1521 172.677 67.1521H170.717V72.2383ZM172.451 67.8958C173.104 67.8958 173.484 68.2448 173.484 68.8546V68.8616C173.484 69.4714 173.104 69.8239 172.451 69.8239H171.627V67.8958H172.451ZM175.074 72.2383H175.983V70.3349H176.967L177.968 72.2383H179.004L177.894 70.1975C178.486 69.9825 178.852 69.4291 178.852 68.7453V68.7382C178.852 67.7549 178.19 67.1521 177.104 67.1521H175.074V72.2383ZM175.983 69.6159V67.8888H176.991C177.562 67.8888 177.922 68.2131 177.922 68.7453V68.7523C177.922 69.2987 177.583 69.6159 177.009 69.6159H175.983ZM179.585 72.2383H180.495V67.1521H179.585V72.2383ZM183.604 72.3264C184.774 72.3264 185.637 71.6038 185.768 70.5605L185.775 70.5253H184.883L184.873 70.5605C184.707 71.1879 184.252 71.5369 183.604 71.5369C182.719 71.5369 182.148 70.8249 182.148 69.6934V69.6899C182.148 68.562 182.715 67.8535 183.604 67.8535C184.266 67.8535 184.714 68.2166 184.862 68.7982L184.88 68.8651H185.771L185.768 68.8299C185.634 67.7936 184.774 67.064 183.604 67.064C182.144 67.064 181.217 68.065 181.217 69.6899V69.6934C181.217 71.3183 182.141 72.3264 183.604 72.3264ZM186.466 72.2383H189.758V71.4734H187.375V70.0248H189.627V69.2881H187.375V67.917H189.758V67.1521H186.466V72.2383Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M26.9964 28.0657C28.6134 28.0657 29.6047 27.1184 29.6047 25.713V21.5979H28.4724V25.6204C28.4724 26.5016 27.9393 27.0788 26.9964 27.0788C26.0536 27.0788 25.5161 26.5016 25.5161 25.6204V21.5979H24.3793V25.713C24.3793 27.1184 25.3839 28.0657 26.9964 28.0657ZM30.7326 27.9556H31.8693V25.854H33.1823C34.4688 25.854 35.3456 24.9992 35.3456 23.7303V23.7215C35.3456 22.4482 34.4688 21.5979 33.1823 21.5979H30.7326V27.9556ZM32.9003 22.5275C33.7154 22.5275 34.1913 22.9637 34.1913 23.7259V23.7347C34.1913 24.4969 33.7154 24.9375 32.9003 24.9375H31.8693V22.5275H32.9003Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M149.879 103.749C150.34 103.998 150.733 104.142 151.064 104.222C151.011 103.879 151.049 103.553 151.158 103.256C151.17 103.204 151.186 103.152 151.213 103.103C151.223 103.081 151.233 103.06 151.244 103.04C151.245 103.037 151.246 103.034 151.247 103.032C151.268 102.992 151.294 102.957 151.322 102.925C151.505 102.657 151.784 102.461 152.116 102.387C152.466 102.309 152.841 102.363 153.171 102.541C153.838 102.902 154.126 103.669 153.863 104.304C153.851 104.342 153.836 104.38 153.817 104.416C153.816 104.418 153.816 104.42 153.814 104.422C153.803 104.444 153.79 104.466 153.771 104.496C153.764 104.507 153.755 104.515 153.748 104.526C153.573 104.802 153.327 105.029 153.027 105.193C153.18 105.304 153.348 105.401 153.529 105.477C153.812 105.596 154.134 105.609 154.416 105.61C155.021 99.8467 160.808 95.3107 167.839 95.3107C169.969 95.3107 172.073 95.7345 173.956 96.5404C174.751 95.5314 176.024 95.021 177.75 95.021H180.027C180.236 95.021 180.43 95.1303 180.538 95.3093C180.646 95.4883 180.652 95.7109 180.555 95.8957L178.564 99.6796C178.543 99.7193 178.563 99.7634 178.587 99.7889C179.336 100.616 179.944 101.522 180.391 102.482C180.661 103.055 181.18 103.412 181.745 103.412L183.147 103.413C184.061 103.412 184.805 104.156 184.805 105.07V108.143C184.805 109.057 184.061 109.8 183.147 109.8H181.745C181.178 109.8 180.66 110.157 180.391 110.733C179.673 112.275 178.527 113.693 177.08 114.831C176.685 115.144 176.449 115.649 176.449 116.18V119.097C176.449 119.426 176.182 119.694 175.853 119.694H172.238C171.908 119.694 171.641 119.426 171.641 119.097V117.447C169.132 118.066 166.398 118.053 163.914 117.416V119.097C163.914 119.426 163.647 119.694 163.317 119.694L159.701 119.694C159.372 119.694 159.105 119.427 159.105 119.097V116.082C159.105 115.559 158.874 115.059 158.491 114.748C155.884 112.65 154.428 109.835 154.367 106.803C154.01 106.8 153.54 106.775 153.072 106.58C152.496 106.34 151.999 105.957 151.639 105.496C150.927 105.475 150.133 105.243 149.313 104.799C149.023 104.643 148.915 104.281 149.072 103.991C149.228 103.7 149.59 103.591 149.88 103.749L149.879 103.749ZM152.602 103.591C152.527 103.55 152.445 103.536 152.377 103.552C152.354 103.557 152.314 103.57 152.295 103.606C152.295 103.607 152.294 103.608 152.294 103.609C152.215 103.762 152.214 103.982 152.288 104.22C152.507 104.143 152.675 104.02 152.765 103.853C152.765 103.853 152.766 103.853 152.766 103.852C152.79 103.804 152.748 103.67 152.602 103.591Z",
    fill: "#31B047"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M163.759 111.964L172.284 101.734",
    stroke: "white",
    strokeWidth: 0.902326
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 170.792,
    cy: 110.259,
    r: 1.25381,
    stroke: "white",
    strokeWidth: 0.902326
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 165.251,
    cy: 103.439,
    r: 1.25381,
    stroke: "white",
    strokeWidth: 0.902326
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 168.021,
    cy: 93.9031,
    r: 5.59453,
    fill: "#FFD44B"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 168.021,
    cy: 93.9031,
    r: 4.35131,
    fill: "url(#paint0_linear_1309_11705)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 166.219,
    y: 93.9033,
    width: 2.54862,
    height: 2.54862,
    transform: "rotate(-45 166.219 93.9033)",
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 160.189,
    cy: 89.4271,
    r: 5.59453,
    fill: "#FFD44B"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 160.189,
    cy: 89.427,
    r: 4.35131,
    fill: "url(#paint1_linear_1309_11705)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 158.387,
    y: 89.4272,
    width: 2.54862,
    height: 2.54862,
    transform: "rotate(-45 158.387 89.4272)",
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 171.378,
    cy: 81.5945,
    r: 5.59453,
    fill: "#FFD44B"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 171.378,
    cy: 81.5945,
    r: 4.35131,
    fill: "url(#paint2_linear_1309_11705)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 169.575,
    y: 81.5947,
    width: 2.54862,
    height: 2.54862,
    transform: "rotate(-45 169.575 81.5947)",
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 168.022,
    cy: 100.057,
    rx: 4.47563,
    ry: 1.67836,
    fill: "#31B047"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M150.879 32.441C151.34 32.6899 151.733 32.8336 152.064 32.9136C152.011 32.5711 152.049 32.2448 152.158 31.9481C152.17 31.8959 152.186 31.8443 152.213 31.7949C152.223 31.7727 152.233 31.7516 152.244 31.7316C152.245 31.7291 152.246 31.7261 152.247 31.7236C152.268 31.6842 152.294 31.6487 152.322 31.6165C152.505 31.3492 152.784 31.153 153.116 31.0787C153.466 31.0007 153.841 31.0545 154.171 31.233C154.838 31.5943 155.126 32.3605 154.863 32.9962C154.851 33.034 154.836 33.0714 154.817 33.1075C154.816 33.1095 154.816 33.112 154.814 33.1142C154.803 33.1361 154.79 33.1575 154.771 33.1877C154.764 33.1994 154.755 33.2072 154.748 33.218C154.573 33.4944 154.327 33.7205 154.027 33.8848C154.18 33.9958 154.348 34.0932 154.529 34.1693C154.812 34.2875 155.134 34.3005 155.416 34.3017C156.021 28.5386 161.808 24.0026 168.839 24.0026C170.969 24.0026 173.073 24.4264 174.956 25.2323C175.751 24.2233 177.024 23.7129 178.75 23.7129H181.027C181.236 23.7129 181.43 23.8222 181.538 24.0012C181.646 24.1802 181.652 24.4028 181.555 24.5876L179.564 28.3715C179.543 28.4112 179.563 28.4553 179.587 28.4808C180.336 29.3078 180.944 30.2141 181.391 31.1738C181.661 31.7474 182.18 32.1043 182.745 32.1043L184.147 32.1051C185.061 32.1043 185.805 32.848 185.805 33.7618V36.8347C185.805 37.7485 185.061 38.492 184.147 38.492H182.745C182.178 38.492 181.66 38.8491 181.391 39.4244C180.673 40.9674 179.527 42.3846 178.08 43.5232C177.685 43.836 177.449 44.3405 177.449 44.8719V47.7888C177.449 48.1182 177.182 48.3855 176.853 48.3855H173.238C172.908 48.3855 172.641 48.1182 172.641 47.7888V46.1393C170.132 46.7576 167.398 46.7445 164.914 46.1079V47.7888C164.914 48.1182 164.647 48.3854 164.317 48.3854L160.701 48.386C160.372 48.386 160.105 48.1188 160.105 47.7894V44.7742C160.105 44.2511 159.874 43.7514 159.491 43.44C156.884 41.3417 155.428 38.5267 155.367 35.4953C155.01 35.4922 154.54 35.467 154.072 35.2722C153.496 35.0318 152.999 34.6492 152.639 34.1876C151.927 34.1674 151.133 33.9351 150.313 33.4914C150.023 33.3346 149.915 32.9727 150.072 32.6824C150.228 32.3921 150.59 32.2831 150.88 32.441L150.879 32.441ZM153.602 32.2833C153.527 32.2422 153.445 32.228 153.377 32.2438C153.354 32.2491 153.314 32.2619 153.295 32.298C153.295 32.2988 153.294 32.2999 153.294 32.3007C153.215 32.4539 153.214 32.674 153.288 32.9115C153.507 32.8347 153.675 32.7123 153.765 32.5452C153.765 32.545 153.766 32.5444 153.766 32.5441C153.79 32.4961 153.748 32.3621 153.602 32.2833Z",
    fill: "#31B047"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M164.759 40.6561L173.284 30.4263",
    stroke: "white",
    strokeWidth: 0.902326
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 171.792,
    cy: 38.9511,
    r: 1.25381,
    stroke: "white",
    strokeWidth: 0.902326
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 166.251,
    cy: 32.1312,
    r: 1.25381,
    stroke: "white",
    strokeWidth: 0.902326
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 169.021,
    cy: 22.5945,
    r: 5.59453,
    fill: "#FFD44B"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 169.021,
    cy: 22.5945,
    r: 4.35131,
    fill: "url(#paint3_linear_1309_11705)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 167.219,
    y: 22.5947,
    width: 2.54862,
    height: 2.54862,
    transform: "rotate(-45 167.219 22.5947)",
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 169.022,
    cy: 28.7482,
    rx: 4.47563,
    ry: 1.67836,
    fill: "#31B047"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M13.9219 10.5308L11.3171 15.0424H16.5267L13.9219 10.5308ZM14.373 35.8049V14.5912H13.4707V35.8049H14.373Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6935 102.842H26.0154C27.9187 102.842 29.0378 101.661 29.0378 99.6475V99.6387C29.0378 97.6296 27.9099 96.4841 26.0154 96.4841H23.6935V102.842ZM24.8302 101.881V97.4446H25.8964C27.1609 97.4446 27.879 98.2244 27.879 99.6431V99.6519C27.879 101.101 27.1741 101.881 25.8964 101.881H24.8302ZM32.7431 102.952C34.6024 102.952 35.7568 101.687 35.7568 99.6652V99.6563C35.7568 97.6384 34.598 96.374 32.7431 96.374C30.8927 96.374 29.7251 97.6384 29.7251 99.6563V99.6652C29.7251 101.687 30.8839 102.952 32.7431 102.952ZM32.7431 101.965C31.6064 101.965 30.8839 101.079 30.8839 99.6652V99.6563C30.8839 98.2421 31.6108 97.3609 32.7431 97.3609C33.8799 97.3609 34.6024 98.2465 34.6024 99.6563V99.6652C34.6024 101.066 33.8931 101.965 32.7431 101.965ZM37.7791 102.842H38.8761L40.1583 98.2817H40.1847L41.4668 102.842H42.5639L44.2689 96.4841H43.0882L41.9823 101.282H41.9603L40.687 96.4841H39.656L38.3827 101.282H38.3607L37.2548 96.4841H36.074L37.7791 102.842ZM45.0179 102.842H46.1503V98.3698H46.1723L49.2784 102.842H50.2918V96.4841H49.1639V100.938H49.1375L46.0401 96.4841H45.0179V102.842Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5352 114.595L16.1399 110.084L10.9304 110.084L13.5352 114.595ZM13.084 83.9161L13.084 110.535L13.9863 110.535L13.9863 83.9161L13.084 83.9161Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1309_11705",
    x1: 165.069,
    y1: 90.6396,
    x2: 171.129,
    y2: 97.0111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.133929,
    stopColor: "#FFC200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.580357,
    stopColor: "#FFC200",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1309_11705",
    x1: 157.237,
    y1: 86.1635,
    x2: 163.297,
    y2: 92.5351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.133929,
    stopColor: "#FFC200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.580357,
    stopColor: "#FFC200",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1309_11705",
    x1: 168.425,
    y1: 78.331,
    x2: 174.486,
    y2: 84.7025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.133929,
    stopColor: "#FFC200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.580357,
    stopColor: "#FFC200",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1309_11705",
    x1: 166.069,
    y1: 19.331,
    x2: 172.129,
    y2: 25.7025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.133929,
    stopColor: "#FFC200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.580357,
    stopColor: "#FFC200",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC200"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPut1);
export default __webpack_public_path__ + "static/media/put1.faa6d93a.svg";
export { ForwardRef as ReactComponent };